<script>
export default {
    name: 'GciLink',
}
</script>
<template>
  <a target="gci" href="https://curation.clinicalgenome.org/dashboard">
    <slot>Gene Curation Interface</slot>
  </a>
</template>